import { render } from "./DatasetCards.vue?vue&type=template&id=371738c6&scoped=true"
import script from "./DatasetCards.vue?vue&type=script&lang=js"
export * from "./DatasetCards.vue?vue&type=script&lang=js"

import "./DatasetCards.vue?vue&type=style&index=0&id=371738c6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/RNAseq_web/prime_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371738c6"]])

export default __exports__